import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pt_filter",
  "use": "icon-pt_filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pt_filter\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M20,4V5.78h-.89l-4.44,6.66V20H9.33V12.44L4.89,5.78H4V4ZM7,5.78l4.08,6.13v6.31h1.78V11.91L17,5.78Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol